<template>
<transition name="slide">
    <div   :class="isShow?'view-log-min-footer':'view-log-realtime-footer'"   v-show="clickCurrent==index">
        <div >
                    <div  style="color:#6f7886;lineHeight:18Px;width:100%;height:50Px;marginBottom:15Px;">
                              <span v-if="isShow">
                              <div class="log-line">
                                    <div style="float:left;">{{$t('language.common.sync')}}:</div>
                                    <div  :class="[$i18n.locale == 'italian'?'catelog-width-it':'catelog-width']"  class="catelog-color catelog-style " @click.stop="toSourceCatalog(allItem.fromItem)" :title="allItem.fromItem.nodes|getCatalog|getCatalogTitle">{{allItem.fromItem.nodes|getCatalog}}</div>
                              </div>
                
                              <div class="log-line">
                                    <div style="float:left;">{{$t('language.common.with')}}:</div>
                                    <div  :class="[$i18n.locale == 'italian'?'catelog-width-it':'catelog-width']"   class="catelog-color catelog-style" @click.stop="toAimCatalog(allItem.toItem)"  :title="allItem.toItem.nodes|getCatalog|getCatalogTitle">{{allItem.toItem.nodes|getCatalog}}</div>
                              </div>
                              </span>
                        <div class="log-line">
                           <div class="log-realTimeline-left" >
                                {{$t('language.common.result')}}:<span v-if="temp && temp.response=='success'"> {{$t('language.common.success')}}</span><span v-if="temp &&temp.response=='error'"> {{$t('language.common.failure')}}</span>
                                <span v-if="temp && temp.response=='cancel'"> {{$t('language.common.cancel')}}</span>
                            </div>
                        </div>
                        <div class="log-line">
                            <div class="log-realTimeline-all" v-if="temp">
                                {{$t('language.common.fileProcess')}}:<span :title="'Add['+temp.addFile+'] Update['+temp.updateFile+'] Delete['+temp.deleteFile+']'"> Add[{{temp.addFile}}]&nbsp;Update[{{temp.updateFile}}]&nbsp;Delete[{{temp.deleteFile}}]</span>
                            </div>   
                        </div>
                         <div class="log-line">
                            <div class="log-realTimeline-left" v-if="temp">
                                 {{$t('language.common.dataProcess')}}:<span :title="getDataProcessTitle(temp)"> {{temp.fileTotalReadedBytes|formatByte}}/{{temp.totalBytes|formatByte}}</span>  
                            </div>  
                        </div>
                        <div class="log-line">
                             <div class="log-realTimeline-left">
                               {{$t('language.cloudSync.createdAt')}}:<span :title="allItem.createTime|transferForMatTime">{{allItem.createTime|transferForMatTime}}</span>
                             </div>
                             <div class="log-line-right" v-if="temp">
                                {{$t('language.cloudSync.lastSync')}}:<span :title="temp.lastSyncTime">{{temp.lastSyncTime}}</span>
                             </div>
                        </div>
                        <div class="log-line">
                             <div class="log-realTimeline-left" v-if="temp">
                               {{$t('language.common.averageRateSpecial')}}:<span :title="getAvgSpeed(temp)"> {{(temp.fileTotalReadedBytes/(temp.taskElaspedTimeLong/1000))|formatByteSpeed}}</span>
                             </div>
                              <div class="log-line-right" v-if="temp">
                                 {{$t('language.common.executedTimes')}}:<span :title="temp.runCount">{{temp.runCount}}</span>
                             </div>
                        </div>
                    </div>
                        <div class="log-line" v-if="temp&&temp.errorList.length">
                               <div class="log-realTimeline-left click-log-red" @click="openFailedFiles()"> {{$t('language.common.viewFailed')}}</div>
                        </div>
                         <div class="log-line" v-if="temp && temp.response=='success'">
                               {{$t('language.common.fileSuccess')}}
                         </div>
        </div>
    </div>
</transition>
</template>

<script>
import taskListUtils from "@/js/workspace/task_list_util.js";
import commonUtils from "@/js/workspace/common_util.js";
export default {
  props: ['clickCurrent', 'index', 'itemDetail', 'allItem','isShow'],
  data: function () {
    return {

    }
  },
  computed: {
    temp: {
      get: function () { return this.itemDetail },
      set: function (val) { return val }
    }
  },
  methods: {
   toSourceCatalog(item) {
            this.$parent.toSourceCatalog(item);
    },
   toAimCatalog(item) {
            this.$parent.toAimCatalog(item);
    },
    getDataProcessTitle (value) {
      let str1 = commonUtils.formatByte(value.fileTotalReadedBytes);
      return str1;
    },
    getAvgSpeed (value) {
      let interval = (value.fileTotalReadedBytes / (value.taskElaspedTimeLong / 1000));
      return this.Utils.formatByteSpeed(interval);
    },
    updatePage (itemDetail) {
      this.temp = itemDetail;
      this.$forceUpdate();
    },
    openFailedFiles () {
      let that = this;
      let failedFilesDialog = this.$parent.$parent.$refs.failedFilesDialog;
      if(!failedFilesDialog){
          failedFilesDialog = this.$parent.$parent.$parent.$refs.failedFilesDialog;
      }
      failedFilesDialog.retryFailedShow = true;
      failedFilesDialog.selectedArr = [];
      failedFilesDialog.transferType = this.itemDetail.type;
      failedFilesDialog.unfinishData = this.itemDetail.errorList;
      $.each(failedFilesDialog.unfinishData, function (index, item) {
        item.fromItem = that.allItem.fromItem;
        item.toItem = that.allItem.toItem;
        if(item.filenode[0] && item.fromItem.nodes[0].fileId != item.filenode[0].fileId){
            var node=item.filenode[0];
            item.fromItem.nodes.unshift(node);
        }
        item.fromItem.id = item.fromItem.nodes[0].fileId;
      });
      
    },
    // retryAll(itemDetail) {
    //     let that = this;
    //     let failedFilesDialog = this.$parent.$parent.$refs.failedFilesDialog;
    //     let errorList = itemDetail.lastLog.errorList;
    //     failedFilesDialog.selectedArr = Object.assign([], errorList);
    //     failedFilesDialog.unfinishData = Object.assign([], errorList);
    //     $.each(failedFilesDialog.selectedArr, function (index, item) {
    //         item.fromItem = Object.assign([], itemDetail.fromItem);
    //         item.toItem = Object.assign([], itemDetail.toItem);
    //     });
    //     failedFilesDialog.retry();
    //     itemDetail.retryed = true;
    //     that.$forceUpdate();

    // },
    toAimRootCatalog (itemDetail) {
      let toItem = itemDetail.toItem;
      let toItemJson = Object.assign({}, toItem);
      let rootNodes = toItemJson.nodes[toItemJson.nodes.length - 1];
      toItemJson.nodes = [];
      toItemJson.nodes.push(rootNodes);
      toItemJson.id = toItemJson.nodes[toItemJson.nodes.length - 1].fileId;
      if (toItemJson.nodes[toItemJson.nodes.length - 1].filename) {
        toItemJson.name = toItemJson.nodes[toItemJson.nodes.length - 1].filename;
      } else {
        toItemJson.name = toItemJson.nodes[toItemJson.nodes.length - 1].fileName;
      }
      this.$parent.$parent.toAimCatalog(toItemJson);
    },
    showStatus (item) {
      let result = taskListUtils.showStatus(item);
      return result;
    },

  },
}
</script>

<style>
.loadViewLogs {
  font-family: sans-serif;
  display: inline-block;
  width: 10px; /*no*/
  min-height: 2px; /*no*/
  padding-right: 2px; /*no*/
  border-left: 2px solid currentColor; /*no*/
  border-right: 2px solid currentColor; /*no*/
  background-color: currentColor;
  background-clip: content-box;
  box-sizing: border-box;
  -webkit-animation: dot 4s infinite step-start both;
  animation: dot 1s infinite step-start both;
}

.loadViewLogs:before {
  font-family: sans-serif;
  content: '...';
}

/* IE8 */
.loadViewLogs::before {
  font-family: sans-serif;
  content: '';
}

:root .loadViewLogs {
  margin-left: 2px; /*no*/
  padding-left: 2px; /*no*/
}
.view-log-realtime-footer {
  width: 100%;
  height: 150px;
  /*no*/
  float: left;
  line-height: 20px;
  /*no*/
  font-size: 12px !important;
  /*no*/
  box-sizing: border-box;
  padding-top: 10px;
  /*no*/
}
.view-log-min-footer {
  width: 100%;
  height: 90px;
  /*no*/
  float: left;
  line-height: 20px;
  /*no*/
  font-size: 13px;
  /*no*/
  box-sizing: border-box;
  padding-top: 10px;
  /*no*/
}

.log-single-left {
  float: left;
  width: 200px;
  /*no*/
}

.log-single-right {
  float: left;
  width: 245px;
  /*no*/
}

.log-failed-left {
  float: left;
  margin: 10px 10px 0 0;
  /*no*/
}

.log-retry-right {
  float: left;
  margin-top: 10px;
  /*no*/
}
.log-realTimeline-left{
    float: left;
    width: 255px;
    /*no*/
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.log-realTimeline-all{
    float: left;
    width: 100%;
    /*no*/
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_task_list/tab_realTime_logs.vue